export default __webpack_public_path__ + "static/media/gallery_09.218e4f63.jpg";